const ZipCityPopup = ({ visible, results, onSelect, onClose }) => {
    if (!visible || results.length === 0) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40" onClick={onClose}>
            <div className="bg-white rounded-lg p-6 w-96 shadow-lg" onClick={e => e.stopPropagation()}>
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-semibold">Select City & State</h3>
                    <button className="text-gray-500 hover:text-black" onClick={onClose}>×</button>
                </div>
                <ul className="space-y-2">
                    {results.map((opt, idx) => (
                        <li key={idx}>
                            <button
                                onClick={() => onSelect(opt)}
                                className="w-full text-left px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded"
                            >
                                {opt.city}, {opt.abbrev}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default ZipCityPopup;
